import React from "react";
import TranslatedPage from "../../containers/TranslatedPage";
import { connect } from "react-redux";
import { selectCollection } from "../../store/home_ui/creators";
import { fetchSuggestionsInCollection } from "../../store/circle_suggestion/operations";
import {
  getCircleSuggestionsForSelectedCollection,
  loadingInitialSuggestionsForSelectedCollection,
} from "../../store/circle_suggestion/selectors";

import LoadingIndicator from "../../components/LoadingIndicator";
import { convertNameToUrl } from "../../utils/utils";
import { navigate } from "../../store/navigation/operations";

import "./WhiteMondayGifts.scss";
import GiftCard from "./GiftCard";

class WhiteMondayGifts extends React.Component{
  componentDidMount(){
    this.props.selectCollection('whitemonday');
    this.props.fetchSuggestionsInCollection('whitemonday', 4, 0);
  }

  handleSuggestionClick=(suggestion)=>{
    this.props.navigate(`/suggestion/whitemonday/${convertNameToUrl(suggestion)}/${suggestion.id}`);
  };

  render(){
    const {loadingInitialSuggestions, suggestions} =  this.props;
    if(!loadingInitialSuggestions && suggestions.length===0){
      return null;
    }
  return (    
    <section className="white-monday-gifts large-padding">
      <div className="main-container">
        <div className="content-wrapper">
          <h1 className="hero-heading how-it-works">
            <TranslatedPage path="whitemonday.content_blocks.whitemonday_gifts_header.heading" />
          </h1>
          {loadingInitialSuggestions && <LoadingIndicator />}
          {!loadingInitialSuggestions && 
            <div className="gift-items-wrapper">
              {suggestions.map((suggestion, idx) => (
                  <GiftCard
                    key={idx}
                    suggestion={suggestion}
                    handleSuggestionClick={this.handleSuggestionClick}
                  />
              ))}             
            </div>
          }
        </div>
      </div>
    </section>
  )};
};

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  suggestions: getCircleSuggestionsForSelectedCollection(state, false),
  loadingInitialSuggestions: loadingInitialSuggestionsForSelectedCollection(state, false)
});

const mapDispatchToProps={
  selectCollection,
  fetchSuggestionsInCollection,
  navigate
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WhiteMondayGifts);

